import { useEffect } from "react";

/**
 * Detects a "pull from left edge" gesture on touch devices and navigates back.
 * - Trigger zone: touch starts within 24px of the left edge
 * - Activation: horizontal movement > 90px, dominant horizontal direction,
 *   completed in < 600 ms (rules out slow drags)
 *
 * Coexists cleanly with iOS Safari's native edge swipe (which the browser
 * intercepts before our handler runs) and with vertical scrolling.
 */
export const useEdgeSwipeBack = () => {
  useEffect(() => {
    let startX = 0;
    let startY = 0;
    let startT = 0;
    let armed = false;

    const onStart = (e) => {
      const t = e.touches[0];
      if (!t) return;
      if (t.clientX <= 24) {
        startX = t.clientX;
        startY = t.clientY;
        startT = Date.now();
        armed = true;
      } else {
        armed = false;
      }
    };

    const onEnd = (e) => {
      if (!armed) return;
      armed = false;
      const t = (e.changedTouches && e.changedTouches[0]) || null;
      if (!t) return;
      const dx = t.clientX - startX;
      const dy = Math.abs(t.clientY - startY);
      const dt = Date.now() - startT;
      if (dx > 90 && dx > dy * 1.5 && dt < 600) {
        if (window.history.length > 1) window.history.back();
      }
    };

    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchend", onEnd);
    };
  }, []);
};
